<script lang="ts">
    import {
        KEY_CODE_ARROW_LEFT,
        KEY_CODE_ARROW_RIGHT,
        KEY_CODE_ESC,
        KEY_CODE_SPACE,
    } from "@/constants";
    import { createEventDispatcher, onMount } from "svelte";

    const dispatch = createEventDispatcher();

    export let listenKeydown = true;
    export let listenKeyup = true;

    onMount(() => {
        listenKeydown && document.addEventListener("keydown", handleKeyDown);
        listenKeyup && document.addEventListener("keyup", handleKeyUp);

        return () => {
            listenKeydown &&
                document.removeEventListener("keydown", handleKeyDown);
            listenKeyup && document.removeEventListener("keyup", handleKeyUp);
        };
    });

    const handleKeyDown = (event: KeyboardEvent) => {
        switch (event.keyCode) {
            case KEY_CODE_ARROW_RIGHT:
                dispatch("keydownArrowRight");
                break;
            case KEY_CODE_ARROW_LEFT:
                dispatch("keydownArrowLeft");
                break;
            case KEY_CODE_ESC:
                dispatch("keydownEsc");
                break;
            case KEY_CODE_SPACE:
                dispatch("keydownSpace");
        }
    };

    const handleKeyUp = (event: KeyboardEvent) => {
        switch (event.keyCode) {
            case KEY_CODE_ARROW_RIGHT:
                dispatch("keyupArrowRight");
                break;
            case KEY_CODE_ARROW_LEFT:
                dispatch("keyupArrowLeft");
                break;
            case KEY_CODE_ESC:
                dispatch("keyupEsc");
                break;
            case KEY_CODE_SPACE:
                dispatch("keyupSpace");
        }
    };
</script>

<slot />
